import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureMeasurementTouch } from '../../shared/lib/measurementContext';

// First-party attribution must not depend on the third-party counter loading.
// Bounded registration UTM capture respects explicit opt-outs and DNT.
export default function MeasurementTouchTracker() {
  const { pathname, search } = useLocation();
  useLayoutEffect(() => { captureMeasurementTouch(); }, [pathname, search]);
  return null;
}
